
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Mailto from 'react-mailto';

import {displayPhone} from '../../../utils/formatting';

import RhinoLoading from '../common/RhinoLoading';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);


class TeamModal extends React.Component {
  
  static propTypes = {
    item: PropTypes.object,
    location: PropTypes.object,
    store_id: PropTypes.string,
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.commonModalResize();
  }

  getTeamPhotoUrl() {
    if(this.props.member) {
      let bioSrc = 'https://ddw2.diamondsdirect.com/img/store/team/' + this.props.store_id + '/' + this.props.member.picture;
      return bioSrc;
    } else {
      return '';
    }
  }

  getEmail() {
    if(!this.props.member) {
      return '';
    }
    if(this.props.member.email) {
      return this.props.member.email;
    }
    if(this.props.location && this.props.member.email === '') {
      return this.props.location.email; 
    } else {
      return '';
    }
    return this.props.member.email;
  }

  getPhone() {
    if(!this.props.member) {
      return '';
    }
    if(this.props.member.phone) {
      return this.props.member.phone;
    }
    if(this.props.location && this.props.member.phone === '') {
      return this.props.location.phone; 
    } else {
      return '';
    }
    return this.props.member.email;
  }

  getName() {
    if(!this.props.member) {
      return '';
    }
    if(this.props.member.name) {
      return this.props.member.name;
    }
  }

  getTitle() {
    if(!this.props.member) {
      return '';
    }
    if(this.props.member.title) {
      return this.props.member.title;
    }
  }

  getBio() {
    if(!this.props.member) {
      return [];
    }
    if(this.props.member.bio) {
      return this.props.member.bio;
    }
  }

  render() {
    return <div className='TeamModal'>
      {!this.props.member ? 
        <RhinoLoading /> :
        <div className='contentWrapper'>
          <div className='closeIcon' onClick={::this.props.closeMethod}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='modalLhs'>

            <div className={'mobileName mobileOnly'}>{this.getName()}</div>
            <div className={'mobileTitle mobileOnly'}>{this.getTitle()}</div>

            <div className='teamPhoto'>
              <img src={this.getTeamPhotoUrl()} />
            </div>
            <div className='contactEmail'>
              <Mailto email={this.getEmail()}>{this.getEmail()}</Mailto>
            </div>
            <div className='contactPhone'>{displayPhone(this.getPhone())}</div>
          </div>
          <div className='modalRhs'>
            <div className={'teamName desktopOnly'}>{this.getName()}</div>
            <div className={'teamTitle desktopOnly'}>{this.getTitle()}</div>
            <div className='teamBioWrapper'>
              {this.getBio().map((line, i) => {
                return <div className='teamBioP' key={i}>{line}</div>
              })}
            </div>
          </div>
        </div>
      }
    </div>
  }
}
export default TeamModal;

function mapStateToProps(state) {
  return {

  };
}

export const TeamModalContainer = connect(
  mapStateToProps,
  allActionCreators
)(TeamModal);


// WEBPACK FOOTER //
// ./src/components/views/store/TeamModal.jsx